module.exports = Studio;


/*****************
 ** WEBPACK FOOTER
 ** external "Studio"
 ** module id = 8
 ** module chunks = 0
 **/